/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, embedOverrides, mediaQuery, centerAbsolutely } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : EMBED ORGANIZE : STYLES --------------- ++++++++++ */
export default theme => ({
	organize: {
		padding: replacePXinStringWithEM('0px 10px'),
		maxWidth: pxToEm(1300),
		'& .inner': {
			background: theme.color.light.light.swatch,
			width: `100%`,
			height: `100%`,
			display: 'flex',
			flexDirection: 'column',
			// !!!!!! do NOT put a transform on this DIV or it will BREAK the drag and drop hit areas ..... DON'T ask WHY

			// ^^^^^ GROUPS TOP LEVEL ^^^^^ //
			'& .group.toplevel': {
				'&:nth-child(1)': { flex: '0 0 0' },
				'&:nth-child(2)': { flex: '1 0 auto' },
			},

			// +++++ DRAG AND DROP +++++ //
			// https://github.com/atlassian/react-beautiful-dnd
			// https://codesandbox.io/s/ql08j35j3q
			'& .droppable': {
				// transition: 'background .2s linear 0s',
				// background: theme.color.neutral.light.swatch,
				// '&.isDraggingOver-true': {
				// 	background: theme.color.neutral.medium.swatch
				// }
			},
			'& .draggable': {
				outline: 'none',
				userSelect: 'none',
				display: 'inline-block',
				width: 'auto',
				transition: 'filter .2s linear 0s',
				'&:hover': {
					filter: 'brightness(65%)'
				}
				// '&.isDragging-true': {
				// 	'& .contentcard': {
				// 		'& .contentvisual': {
				// 			// extend: boxShadow.blue
				// 		}
				// 	}
				// }
			},

			// ***** PAGE TITLE ***** //
			'& .pagetitle.title': {
				margin: replacePXinStringWithEM('0 0 20px'),
				'& h2': {
					color: theme.color.supporting.dark.swatch,
					extend: theme.typography.size.medium
				}
			},

			// ***** HEADLINE ***** //
			'& .headline': {
				position: 'relative',
				marginBottom: pxToEm(5),
				display: 'flex',
				// groups
				'&.live': {
					justifyContent: 'space-between',
					alignItems: 'baseline',
					flexWrap: 'wrap'
				},
				'&.notlive': {
					flexDirection: 'column',
					'& .group.headline-group:first-child': {
						marginBottom: pxToEm(15)
					}
				},

				// innards
				'& h3': {
					color: theme.color.primary.medium.swatch,
					extend: theme.typography.size.small,
					fontWeight: 'normal',
					marginBottom: pxToEm(0)
				},
				'& .randomize': {
					color: theme.color.supporting.dark.swatch,
					fontSize: pxToEm(16),
					'& .toggle': { marginRight: pxToEm(7) },
					display: 'flex',
					alignItems: 'center'
				}
			},

			// ***** CONTENT PIECE ***** //
			'& .contentpieces': {
				'& .cardcontainer': {
					overflow: 'auto',
					overflowY: 'hidden',
					whiteSpace: 'nowrap',
					width: '100%',
					textAlign: 'left',
					padding: replacePXinStringWithEM(`15px 10px`),
					'& .contentcard': {
						marginRight: pxToEm(20),
						marginBottom: pxToEm(12),
						'& .contentvisual': {
							transition: 'box-shadow .2s linear 0s',
							'& .delete': {
								display: 'none' // no need to delete newly added content on this page, user can do on customize page
							}
						}
					},
					'& .highlighted-true':{
						'& .contentvisual': {
							'& .overlay': {
								opacity: '1',
								zIndex: '8',
								'& .icon': {
									display: 'none'
								}
							},
							'& .imageindicator': {
								opacity: '0'
							}
						}
					}
				},

				// ..... LIVE ..... //
				'&.live': {
					'& .cardcontainer': {
						height: pxToEm(240),
						marginBottom: pxToEm(30),
						borderBottom: replacePXinStringWithEM(`2px dotted #BABABA`),
						'& .contentcard': {
							'& .contentnumber': {
								order: '2'
							},
							'& .contenttype': {
								fontSize: '60%'
							},
							'& .contentvisual': {
								order: '1'
							},
							extend: embedOverrides(55)
						},
					}
				},

				// ..... NOT LIVE ..... //
				'&.notlive': {
					'& .cardcontainer': {
						height: pxToEm(240),
						'& .contentcard': {
							opacity: '.4', // grey this out to show that it's not live anymore
							'& .contentnumber': {
								display: 'none'
							},
							'& .contenttype': {
								fontSize: '45%'
							},
							extend: embedOverrides(40)
						}
					}
				}

			}

		},
		
		// ..... RAIL ..... //
		'&.rail': {
			'& .contentpieces': {
				'&.live': {
					'& .cardcontainer': {
						'& .contentcard': {
							'& .contentvisual': {
								height: pxToEm(162),
								width: pxToEm(140)
							}
						}
					}
				},
				'&.notlive': {
					'& .cardcontainer': {
						'& .contentcard': {
							'& .contentvisual': {
								height: pxToEm(116),
								width: pxToEm(100)
							}
						}
					}
				}
			}
		},

        ///-------center pagination -------//
        '& .pagination':{
            width: '100%',
            textAlign: 'center'
        },
		// ..... CONTENT ..... //
		'&.incontent': {
			'& .contentpieces': {
				'&.live': {
					'& .cardcontainer': {
						'& .contentcard': {
							'& .contentvisual': {
								width: pxToEm(264),
								height: pxToEm(156)
							}
						}
					}
				},
				'&.notlive': {
					'& .cardcontainer': {
						'& .contentcard': {
							'& .contentvisual': {
								width: pxToEm(216),
								height: pxToEm(112)
							}
						}
					}
				}
			}
		}
	}
});
